























































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import LineRegistButton from "../student/register/LineRegistButton.vue";
import PagesMixin from "../components/organisms/PagesMixin";

@Component({ components: { LineRegistButton } })
export default class EntrancePage extends Mixins(PagesMixin) {
  studentLogin() {
    this.$router.push({ path: "/student-login-page?building=co01" });
  }
  teacherTop() {
    this.$router.push({ path: "/teacher-login-page?building=co01" });
  }

  teacherRegist() {
    this.$router.push({ path: "/teacher-term-of-use-page?building=co01" });
  }

  mailRegist() {
    this.$router.push({ path: "/student-mail-register-page?building=co01" });
  }
}
